<template>
  <div class="my_edit_item">
    <!-- <span class="my_title font_size">
      {{ title }}
    </span> -->
    <el-select :value="tempValue" size="medium" style="width: 264px" @change="changeSelected">
      <el-option v-for="item in fontFamilyOptions" :key="item.value" :label="item.label" :value="item.value">
        <span :style="{ fontFamily: 'demo-' + item.value, color: '#333' }">{{ item.label }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'FontFamily',
  data() {
    return {
      tempValue: this.value
    }
  },
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: {
      // 组件的标题
      type: String,
      default: '字体'
    },
    value: {
      type: String
    },
    optionsType: {
      type: String,
      default: 'font'
    }
  },
  computed: {
    fontFamilyOptions() {
      return this.$store.state.options.fontFamily
    }
  },
  created() {
    this.tempValue = this.value
    const arr = ['font-4', 'font-26', 'font-29', 'font-30', 'font-33', 'font-41', 'font-43']
    if (arr.includes(this.tempValue)) {
      this.tempValue = 'initial'
    }
  },
  watch: {
    value(val) {
      this.tempValue = val
    }
  },
  methods: {
    changeSelected(val) {
      this.$emit('update:value', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .my_select_index .title {
  display: none;
}
.font_size {
  margin-bottom: 11px;
}
</style>
